import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { THEME_COLORS } from "../themes";

const TextInputV3 = styled(TextField)(() => ({
  "& .MuiInput-underline:after": {
    borderBottomColor: THEME_COLORS.purple,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: THEME_COLORS.purple,
    },
    "&:hover fieldset": {
      borderColor: THEME_COLORS.purple,
    },
    "&.Mui-focused fieldset": {
      borderColor: THEME_COLORS.purple,
    },
  },
}));

export default TextInputV3;
